import "react-phone-number-input/style.css";
import {
    Dropdown,
    Flex,
    Input,
    InputLabel,
    Menu,
    Table,
    Text,
} from "@fluentui/react-northstar";
// import MuiPhoneNumber from "material-ui-phone-number";
import PhoneInput from "react-phone-number-input";
import styled, { css } from "styled-components";
import { DEVICE } from "../../constants/responsive";

export const ContainerCard = styled(Flex)`
    padding: 24px 8px;
    gap: 24px;
    margin-top: 16px;
    border-top: 4px solid var(--Light-theme-Rest-Border-Brand-Border-1, #9299f7);
    background: var(--Light-theme-Rest-Background-Default-Background, #fff);

    /* shadow-4 */
    box-shadow: 0px 1.6px 3.6px 0px rgba(0, 0, 0, 0.11),
        0px 0.3px 0.9px 0px rgba(0, 0, 0, 0.07);

    @media ${DEVICE.mobileS} {
        padding: 0px;
    }
    @media ${DEVICE.tablet} {
        padding: 24px 8px;
    }
`;

export const DropdownFixed = styled(Dropdown)`
    /* position: fixed; */
    width: ${({ width }) => (width ? width : "700px")};
    /* margin-top: 20px; */
    z-index: 3;
    /* top: 15px; */
`;

export const ContainerFluid = styled(Flex)`
    width: 100%;
    margin-top: 0px;
`;

export const LabelRequired = styled(Text)`
    color: #c4314b;
    font-size: 12px;
    font-style: normal;
    font-weight: 350;
    line-height: 16px; /* 133.333% */
    margin-left: 2px;
`;

export const Container = styled(Flex)`
    max-width: 1440px;
    margin: 0 auto;
    @media ${DEVICE.mobileS} {
        width: 100%;
        max-width: auto;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
    }
    @media ${DEVICE.mobileL} {
        flex-direction: row;
        align-items: center;
    }
`;

export const WrapperIcon = styled(Flex)`
    width: 32px;
    height: 32px;
    border-radius: 4px;
    background-color: #e8ebfa;
    color: white;
`;

export const MenuStyle = styled(Menu)`
    border: 0;
    outline: 0;
    > li[data-aa-class="Menu__wrapper"] {
        background-color: transparent;
        box-shadow: none;
        > a[role="menuitem"] {
            ${({ padding }) =>
                padding
                    ? css`
                          padding: ${padding};
                      `
                    : ""};
        }
    }
    .ui-menu__itemindicator {
        display: none;
    }
`;

export const ErrorMessage = styled(InputLabel)`
    color: var(--color-danger);
`;

export const Label = styled(Text)`
    -webkit-text-size-adjust: 100%;
    font-size: 0.875rem;
    text-align: left;
    color: rgb(17, 16, 15);
    unicode-bidi: isolate;
    margin: 0px;
    padding: 0px;
    box-sizing: border-box;
    display: block;
    transition: all 0.2s ease 0s;
    line-height: 1rem;
    margin-bottom: 0.25rem;
`;

export const MuiPhoneNumberStyle = styled(Input)`
    background-color: white;
    width: 100%;
    max-width: 600px;
    border-radius: 4px;
    border: ${({ error }) =>
        error ? "1px solid var(--color-danger) !important" : "0px !important"};
    overflow: hidden !important;

    .css-1ptx2yq-MuiInputBase-root-MuiInput-root:after {
        border-color: var(--color-primary) !important;
    }

    .MuiInput-underline {
        padding: 2px 8px !important;
    }

    .MuiInput-underline::before {
        border: 0px !important;
    }

    .css-1ptx2yq-MuiInputBase-root-MuiInput-root:before {
        animation: none !important;
        transition: none !important;
    }
    .css-1ptx2yq-MuiInputBase-root-MuiInput-root:after {
        transition: none !important;
    }
`;

export const PhoneInputStyle = styled(PhoneInput)`
    background-color: ${({ $inverted }) => ($inverted ? "#f3f2f1" : "white")};
    padding-left: 0.75rem;
    padding-right: 2rem;
    padding-block: 0.3125rem;
    border-radius: 4px;
    border: ${({ error }) =>
        error ? "1px solid var(--color-danger) !important" : "0px !important"};
    max-width: ${({ $fill }) => ($fill ? "100%" : "600px")};
    > input {
        border: 0;
        height: 20px;
        outline: 0;
        background-color: ${({ $inverted }) =>
            $inverted ? "#f3f2f1" : "white"};
    }
`;
